<pagination>

    <div class="flex flex-col items-center gap-4 pt-4 md:flex-row {props.hidepagelength ? 'md:justify-end' : 'md:justify-between'}">
        <div if="{!props.hidepagelength}">
            <label class="me-2 text-sm font-medium" for="pagination-pagelength">{locale?.t('pagelength')}:</label>
            <select id="pagination-pagelength" class="select w-24 bg-white focus:outline-none focus:ring-0 font-medium" value="{state.pageLength}" onchange="{onPageLengthChange}">
                <option each="{len in pageLengths()}" value="{len}" selected="{state.pageLength === len}">{len}</option>
            </select>
        </div>

        <!-- Page navigation -->
        <div class="btn-group flex flex-row gap-1 overflow-hidden" if="{state.totalPages > 1}">
            <button class="btn btn-ghost bg-transparent border-0 px-1 focus:outline-none focus:ring-0 disabled:bg-transparent {state.pageIndex === 1 ? 'invisible' : ''}"
                    disabled="{state.pageIndex === 1}"
                    aria-label="{locale?.t('previous')}"
                    onclick={() => onPageIndexChange(state.pageIndex - 1)}>
                <i class="icon-metalark-chevron-left"></i>
            </button>

            <!-- First page -->
            <button class="btn focus:outline-none focus:ring-0 {state.pageIndex === 1 ? 'btn-primary' : 'bg-white'}"
                    onclick={() => onPageIndexChange(1)}>1</button>

            <!-- Left ellipsis -->
            <span if="{state.pageIndex > 4}">...</span>

            <!-- Pages around current -->
            <button each="{p in Array.from({ length: state.totalPages }, (_, i) => i + 1)}"
                    if="{p > 1 && p < state.totalPages && Math.abs(p - state.pageIndex) <= 2}"
                    class="btn focus:outline-none focus:ring-0 {p === state.pageIndex ? 'btn-primary' : 'bg-white'}"
                    onclick="{() => onPageIndexChange(p)}">
                {p}
            </button>

            <!-- Right ellipsis -->
            <span if="{state.pageIndex < state.totalPages - 3}">...</span>

            <!-- Last page -->
            <button if="{state.totalPages > 1}" class="btn focus:outline-none focus:ring-0 {state.pageIndex === state.totalPages ? 'btn-primary' : 'bg-white'}"
                    onclick={() => onPageIndexChange(state.totalPages)}>{state.totalPages}</button>

            <button class="btn btn-ghost bg-transparent border-0 px-1 focus:outline-none focus:ring-0 disabled:bg-transparent {state.pageIndex === state.totalPages ? 'invisible' : ''}"
                    disabled="{state.pageIndex === state.totalPages}"
                    aria-label="{locale?.t('next')}"
                    onclick={() => onPageIndexChange(state.pageIndex + 1)}>
                <i class="icon-metalark-chevron-right"></i>
            </button>
        </div>
    </div>

    <script>
        export default {
            includeTools: false,

            state: {
                pageLength: null,
                pageIndex: null,
                totalPages: null
            },

            props: {
                pagelength: null,
                pageindex: null,
                totalpages: null,
                hidepagelength: false
            },

            onMounted() {
                this.syncProps();
            },
            onBeforeMount() {
                this.syncProps();
            },
            onBeforeUpdate() {
                this.syncProps();
            },
            syncProps() {
                // this.update({
                //     pageLength: this.props.pagelength,
                //     pageIndex: this.props.pageindex,
                //     totalPages: this.props.totalpages
                // });


                // let shouldUpdate = false;
                //
                // if (
                //     this.state.pageIndex !== this.props.pageindex ||
                //     this.state.pageLength !== this.props.pagelength ||
                //     this.state.totalPages !== this.props.totalpages
                // ) {
                //     this.state.pageLength = this.props.pagelength;
                //     this.state.pageIndex = this.props.pageindex;
                //     this.state.totalPages = this.props.totalpages;
                //     shouldUpdate = true;
                // }
                //
                // console.log(this.state);
                // console.log(shouldUpdate);
                //
                // if (shouldUpdate) this.update();

                this.state.pageLength = this.props.pagelength;
                this.state.pageIndex = this.props.pageindex;
                this.state.totalPages = this.props.totalpages;
            },
            pageLengths() {
                return this.props.pagelengths || [10, 20, 50, 100];
            },
            onPageLengthChange(e) {
                this.props.onPageLengthChange(e);
            },
            onPageIndexChange(newIndex) {
                this.props.onPageIndexChange(newIndex);
            },
        }
    </script>
</pagination>